import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { useAuth0 } from '@auth0/auth0-react'; // Added for Auth0 integration
import './OcodyHomepage.css';

// interface OcodyHomepageProps { // Remove onStartCoding
//   onStartCoding: () => void;
// }
// No props needed for now, so we can remove OcodyHomepageProps or leave it empty
interface OcodyHomepageProps {}


const OcodyHomepage: React.FC<OcodyHomepageProps> = (/*{ onStartCoding }*/) => { // Remove onStartCoding from destructuring
  const navigate = useNavigate(); // Initialize navigate
  const { loginWithRedirect, isAuthenticated, isLoading, logout } = useAuth0(); // Added for Auth0
  return (
    <div className="ocody-homepage-container">
      <header>
        <div className="header-main-content"> {/* Wrapper for logo and title */}
          <div className="logo">
            <i className="fas fa-code"></i> Ocody <span className="beta-tag">beta</span>
          </div>
          <h1>Your Live Coding Partner</h1>
        </div>
        <nav className="header-nav">
          {isLoading ? (
            <button className="nav-button" disabled>Loading...</button>
          ) : !isAuthenticated ? (
            <button className="nav-button" onClick={() => loginWithRedirect()}>
              Log In with Auth0
            </button>
          ) : null}
          {isAuthenticated && (
            <button 
              className="nav-button" 
              onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
            >
              Log Out
            </button>
          )}
          <button className="nav-button" onClick={() => navigate('/payment')}>
            Payment
          </button>
        </nav>
      </header>

      <section className="hero">
        <p>Start coding with Ocody right now! Share your screen, get instant help, and code together in real-time. No setup needed - just jump in and start building something amazing together.</p>
        <div className="hero-buttons"> {/* Added a div to group buttons */}
          <button className="cta-button" onClick={() => navigate('/app')}> {/* Navigate to /app */}
            <i className="fas fa-play-circle"></i> Start Coding Now <i className="fas fa-arrow-right"></i>
          </button>
        </div>

      </section>



      <section className="cta-bottom new-design">
        <h2>Start Coding Together, Right Now</h2>
        <p>The fastest way to get coding help - share your screen and start collaborating instantly</p>
        
        <div className="new-features-grid">
          <div className="feature-card">
            <i className="fas fa-file-code fa-2x"></i>
            <h3>Start Coding Instantly</h3>
            <p>Jump straight into coding - no setup, downloads, or account creation required</p>
          </div>
          <div className="feature-card">
            <i className="fas fa-desktop fa-2x"></i>
            <h3>One-Click Screen Share</h3>
            <p>Share your IDE, terminal, or browser instantly with a simple screenshot</p>
          </div>
          <div className="feature-card">
            <i className="fas fa-bolt fa-2x"></i>
            <h3>Live Code Collaboration</h3>
            <p>Code together in real-time with an AI that understands your context and goals</p>
          </div>
          <div className="feature-card">
            <i className="fas fa-heart fa-2x"></i>
            <h3>Supportive Coding Partner</h3>
            <p>Get encouraging, patient guidance that adapts to your skill level and learning style</p>
          </div>
          <div className="feature-card">
            <i className="fas fa-comments fa-2x"></i>
            <h3>Natural Conversation</h3>
            <p>Chat naturally about your code - ask questions, discuss solutions, brainstorm ideas</p>
          </div>
          <div className="feature-card">
            <i className="fas fa-user-friends fa-2x"></i>
            <h3>Always Ready to Help</h3>
            <p>Your coding partner is available 24/7, ready to jump into any project or challenge</p>
          </div>
        </div>

        <div className="final-cta-section">
          <h2>Ready to Start Coding?</h2>
          <p>No waiting, no setup - jump in and start building with your AI coding partner</p>
          <button className="cta-button" onClick={() => navigate('/app')}>
            <i className="fas fa-play-circle"></i> Start Coding Now
          </button>
        </div>
      </section>

      {/* Footer can be added here or as a global component */}
      {/* 
      <footer>
        <p>&copy; 2025 Ocody. All rights reserved.</p>
      </footer> 
      */}
    </div>
  );
};

export default OcodyHomepage;
